<template>
  <div class="digital-service-navigation-tabs">
    <scrolling-tab-header v-show="isMainPage"
                          v-bind="[$props, $attrs]"
                          :tab-list="mainServicesMenu"
                          @tab-change="selectTab"
                          ref="scrollingTabs"
                          class="digital-service-tabs"/>
    <base-button v-show="!isMainPage"
                 variant="text"
                 class="back-button"
                 @click="goToParent">
      <i class="icon-sc-chevron-left"></i> {{ $t('common.back') }}
    </base-button>
  </div>
</template>

<script>
import ScrollingTabHeader from '@/components/common/tabs/scrolling-tab-header'
import { menuMap } from '@/components/common/navigation/config/digitalServicesSidebarConfig'
import { supportMenu } from '@/components/common/navigation/config/supportSidebarConfig'

const menus = {
  'digital-service': menuMap,
  support: supportMenu
}

export default {
  name: 'sidebar-with-contact-nav-tabs',
  components: { ScrollingTabHeader },
  props: {
    selectedTab: String,
    menuType: {
      type: String,
      default: 'digital-service',
      validator: value => {
        return ['digital-service', 'support'].includes(value)
      }
    },
    additionalServices: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tabName: ''
    }
  },
  computed: {
    /**
     * Simple array consisting of names of the main pages, without submenus
     * * @returns { Array }
     */
    mainServicesMenu () {
      const menu = menus[this.$props.menuType].filter(item => this.additionalServices.includes(item.name))
      return (menu.length ? menu : menus[this.$props.menuType]).map(item => item.title)
    },
    /**
     * Shows if user is on the main page, or on the page from submenu
     * * @returns Object or undefined
     */
    isMainPage () {
      return menus[this.$props.menuType].find(item => item.name === this.tabName)
    }
  },
  methods: {
    /**
     * Selects the tab and emits the event with service name
     * Used when user clicks manually on tabs
     * @param tab { String } The title of the tab, used to find the name for emit event
     */
    selectTab (tab) {
      this.tabName = menus[this.$props.menuType].find(item => item.title === tab).name || ''
      this.$emit('tab-change', this.tabName)
    },
    /**
     * Underlines the first tab
     */
    markFirstTab () {
      this.$refs.scrollingTabs.selectedTab = menus[this.$props.menuType][0].title
      this.tabName = menus[this.$props.menuType][0].name
    },
    /**
     * Underlines the tab for the passed name
     * @param name { String } name of the service
     */
    markTabUsingName (name) {
      this.tabName = name
      const activeTab = menus[this.$props.menuType].find(item => item.name === name)
      if (activeTab) this.$refs.scrollingTabs.selectedTab = activeTab.title
    },
    /**
     * Emits an event with parent name when mobile user is on the page from submenu that's not visible in main navigation
     */
    goToParent () {
      let parentName = ''

      menus[this.$props.menuType].forEach(item => {
        const parent = item.submenu.find(sub => sub.name === this.tabName)
        if (parent) parentName = item.name
      })

      this.$emit('tab-change', parentName)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$props.selectedTab) {
        this.markTabUsingName(this.$props.selectedTab)
      } else {
        this.markFirstTab()
      }
    })
  }
}
</script>

<style lang="scss">
.digital-service-tabs.sc-tabs-container {
  margin-bottom: -2.9rem !important;

  .sc-scrolling-tabs li.single-tab {
    margin-right: 2.4rem;
  }

  .sc-scrolling-tabs li.single-tab a {
    padding-top: 0;
    font-size: 1.6rem;

    &.active {
      box-shadow: inset 0 -3px 0 #ffffff;
    }
  }
}

.digital-service-navigation-tabs .back-button.base-button.variant-text {
  color: $white !important;
  margin-top: -1rem;

  i {
    font-size: 1.4rem;
    margin-right: 1.6rem;
  }
}
</style>
